/**
 * Utility functions
 */

// Extend jQuery with urlParam
declare global {
  interface JQueryStatic {
    urlParam(name: string): string | null;
  }
}

/**
 * Get URL parameter by name
 */
export function urlParam(name: string): string | null {
  const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results === null) {
    return null;
  }
  return decodeURIComponent(results[1]) || null;
}

// Add to jQuery
if (typeof $ !== 'undefined') {
  $.urlParam = urlParam;
}

/**
 * HTML escape helper to prevent XSS
 */
export function escapeHtml(text: unknown): string {
  if (text === null || text === undefined) return '';
  const div = document.createElement('div');
  div.textContent = String(text);
  return div.innerHTML;
}

/**
 * Escape for use in HTML attributes (e.g., onclick handlers)
 */
export function escapeAttr(text: unknown): string {
  if (text === null || text === undefined) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/**
 * Format bytes as human-readable string
 */
export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Format seconds as human-readable duration.
 * Always shows exactly two units for uniform width (prevents layout shift
 * when counters tick across unit boundaries).
 *   < 1h:   "05m 30s"
 *   < 1d:   "02h 15m"
 *   >= 1d:  "3d 08h"
 */
export function formatDuration(seconds: number): string {
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const pad = (n: number) => n < 10 ? `0${n}` : `${n}`;

  if (days > 0) return `${days}d ${pad(hours)}h`;
  if (hours > 0) return `${hours}h ${pad(minutes)}m`;
  return `${minutes}m ${pad(secs)}s`;
}
